import { Alert } from "react-bootstrap";

const errors = {
  403: 'Acceso denegado. No cuentas con permiso para ver esta página.',
  404: 'Página no encontrada.',
  default: 'Sucedió un error inesperado. Por favor intenta de nuevo más tarde.'
}
function ErrorAlert ({ code }) {
  
  return <Alert variant="danger">
    <p>Error: {errors[code] || errors.default}</p>
  </Alert>
}

export default ErrorAlert;
